<template>
  <div v-if="!item.hidden && !shouldHideWhenNoChildren" class="menu-wrapper">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
          (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
          !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)" :data-testid="`menu-item-${onlyOneChild.meta.title}`">
        <el-menu-item
          v-featureKey="item.meta?.action || item.meta?.actions"
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <div class="flex justify-between items-center h-full whitespace-normal">
            <item
              :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
              :title="$t(onlyOneChild.meta.title)"
            />
            <Tag v-if="onlyOneChild.name === 'HomePage' && haveUnreadAnnouncements" type="danger">New</Tag>
          </div>
        </el-menu-item>
      </app-link>
    </template>

    <el-menu-item-group
      v-else-if="item.isGroup"
      v-featureKey="item.meta?.action || item.meta?.actions"
      class="p-0 whitespace-normal"
      :index="resolvePath(item.path)"
      :data-testid="`menu-group-${item.meta.title}`"
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="$t(item.meta.title)"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        v-featureKey="child.meta?.action || child.meta?.actions"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-menu-item-group>

    <el-submenu
      v-else
      ref="subMenu"
      v-featureKey="item.meta?.action || item.meta?.actions"
      :index="resolvePath(item.path)"
      popper-append-to-body
      :data-testid="`sub-menu-${item.meta.title}`"
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="$t(item.meta.title)"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        v-featureKey="child.meta?.action || child.meta?.actions"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-submenu>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import path from 'path'
import Item from './Item'
import AppLink from './Link'
import { filter, get } from 'lodash'

export default defineComponent({
  name: 'SidebarItem',
  components: {
    Item,
    AppLink,
  },
  props: {
    haveUnreadAnnouncements: Boolean,
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data () {
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      isActive: false,
    }
  },
  computed: {
    shouldHideWhenNoChildren () {
    // 如果沒有子路由，不需要隱藏
      if (!this.item.children || get(this.item, 'children.length') === 0) {
        return false
      }

      // 檢查是否所有子路由都被隱藏
      const showingChildren = filter(get(this.item, 'children'), (child) => !child.hidden)

      // 如果所有子路由都被隱藏，且父路由本身沒有直接功能（沒有 component），則隱藏整個項目
      if (showingChildren.length === 0 && !this.item.alwaysShow) {
        return true
      }

      return false
    },
  },
  watch: {
    $route: 'activeSubPath',
  },
  mounted () {
    this.activeSubPath()
  },
  methods: {
    hasOneShowingChild (children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath (routePath) {
      return path.resolve(this.basePath, routePath)
    },
    activeSubPath () {
      if (this.onlyOneChild) {
        const childPath = this.resolvePath(this.onlyOneChild.path)
        this.isActive = this.$route.path.indexOf(childPath) >= 0
      }
    },
  },
})
</script>

<style scoped lang="scss">
::v-deep .el-menu-item {
  @apply py-[6px] rounded-sm text-normal leading-normal h-auto px-[10px];
  // line-height: unset;
}

.el-menu-item:hover {
  @apply bg-primary-100 text-white font-bold leading-normal;
}

::v-deep .el-menu-item.is-active {
  @apply bg-primary-100 text-white font-bold leading-normal;
}

::v-deep .el-menu-item-group__title {
  @apply text-primary-100 font-bold text-sub;
}

// submenu
.el-submenu .el-menu-item {
  @apply py-[6px] rounded-sm leading-normal h-auto px-[40px];
}

::v-deep .el-submenu__title {
  @apply flex items-center rounded-sm text-normal leading-normal whitespace-normal h-auto min-h-[36px];
  // line-height: unset;
}

::v-deep .el-submenu__title:hover {
  @apply bg-primary-100 text-white font-bold leading-normal whitespace-normal;
}

.menu-wrapper {
  @apply mb-[8px];
}
::v-deep .el-menu--inline {
  @apply mt-[8px];
}
</style>
